<template>
	<div class="center_datapanel_container">
		<div class="container_title_box">
			<div class="title">课程数据面板</div>
		</div>

		<!-- 无数据状态 -->
		<div class="empty_box" v-if="!detail">
			<img class="empty_icon" src="../../assets/images/empty.png" />
			<div class="empty_texts">
				<span class="empty_text">您暂无相关数据</span>
			</div>
		</div>

		<!-- 有数据状态 -->
		<div class="data_box" v-if="detail">
			<!-- 数据模块1 -->
			<div class="cells_title">数据概况</div>
			<div class="cells">
				<div class="cell bg1">
					<div class="cell_hd">
						<div class="value">{{detail.view_course_count}}</div>
						<div class="unit">门</div>
					</div>
					<div class="cell_ft">学习课程</div>
				</div>
				<div class="cell bg2">
					<div class="cell_hd">
						<div class="value">{{detail.view_day_count}}</div>
						<div class="unit">天</div>
					</div>
					<div class="cell_ft">学习周期</div>
				</div>
				<div class="cell bg3">
					<div class="cell_hd">
						<div class="value">{{detail.view_class_hour}}</div>
						<div class="unit">学时</div>
					</div>
					<div class="cell_ft">完成学时</div>
				</div>
			</div>

			<!-- 数据模块2 -->
			<div class="cells_title">本周学习趋势</div>
			<div class="chart_box">
				<div style=" height: 300px;" ref="lineChart" id="lineChart"></div>
			</div>


			<!-- 数据模块3、4 -->
			<div class="cells_box">
				<div class="cells_flex">
					<div class="cells_title">课程完成情况</div>
					<div class="chart_box">
						<div style=" height: 300px;" ref="pieChart" id="pieChart"></div>
					</div>
				</div>
				<div class="cells_flex">
					<div class="cells_title">学习兴趣分布</div>
					<div class="chart_box">
						<div style=" height: 300px;" ref="radarChart" id="radarChart"></div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";
	import * as echarts from "echarts";

	export default {
		data() {
			return {
				detail: null,
				lineChart: null,
				pieChart: null,
			};
		},
		created() {
			document.title = "";
			this.getDetail(()=>{
				this.$nextTick(() => {
					this.initLineEcharts();
					this.initPieEcharts();
					this.initRadarEcharts();
				});
			});
		},
		computed: {
			lineOption: {
				get() {
					var categorys = [];
					var values = [];
					this.detail.week_day_data.forEach((item, index) => {
						categorys.push(item.weekday);
						values.push(item.total);
					});

					return {
						xAxis: {
							type: 'category',
							data: categorys
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: values,
							type: 'line',
							smooth: true,
							label: {
								show: true,
								position: 'top', // 可以调整标签的位置，比如 'top' 或 'bottom'
								formatter: function(params) {
									return params.value + ' 分钟'; // 假设单位是“单位”
								}
							}
						}]
					}
				},
				set() {}
			},
			pieOption: {
				get() {
					var arr = new Array();
					this.detail.course_data.forEach((item, index) => {
						var obj = new Object();
						obj.name = item.title;
						obj.value = item.total;
						arr.push(obj);
					});

					return {
						tooltip: {
							trigger: 'item'
						},
						legend: {
							orient: 'vertical',
							bottom: '0',
							left:'0'
						},
						series: [{
							type: 'pie',
							radius: '50%',
							data: arr,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							}
						}]
					}
				},
				set() {}
			},
			radarOption: {
				get() {
					
					var arr = new Array();
					var arr2 = new Array();
					var arr3 = new Array();
					var max = 0.0;
					this.detail.category_course_data.forEach((item, index) => {
						var obj = new Object();
						obj.name = item.title;
						arr.push(obj);
						arr2.push(item.count);
						arr3.push(item.total);
						
						if(item.total>max){
							max = item.total;
						}
					});
					arr.forEach((item, index) => {
						item.max = max * 1.5;
					});
					
					return {
					  radar: {
						// shape: 'circle',
						indicator: arr
					  },
					  legend: {
					      data: ['课程数量', '学习时长'],
						  bottom: '0',
						  right:'0',
						  orient: 'vertical',
					  },
					  series: [
						{
						  type: 'radar',
						  data: [
							{
							  value: arr2,
							  name: '课程数量'
							},
							{
							  value: arr3,
							  name: '学习时长'
							}
						  ]
						}
					  ]
					};
				},
				set() {}
			}

		},
		methods: {
			initLineEcharts() {
				if (!this.lineChart) {
					this.lineChart = echarts.init(this.$refs.lineChart);
				};
				this.lineChart.setOption(this.lineOption);
			},
			initPieEcharts() {
				if (!this.pieChart) {
					this.pieChart = echarts.init(this.$refs.pieChart);
				};
				this.pieChart.setOption(this.pieOption);
			},
			initRadarEcharts() {
				if (!this.radarChart) {
					this.radarChart = echarts.init(this.$refs.radarChart);
				};
				this.radarChart.setOption(this.radarOption);
			},
			getDetail(callback) {
				var that = this;
				var url = apiUrl.tt_data_panel_detail_get;
				this.Ajax(url, {}, (data, code, msg) => {
					that.detail = data;
					if(callback) callback();
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.center_datapanel_container {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #fff;

		.container_title_box {
			display: flex;
			align-items: flex-end;

			.title {
				font-size: 17px;
				margin-right: 15px;
			}
		}

		.border-no {
			border-bottom: none !important;
		}

		.empty_box {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.empty_icon {
				width: 220px;
				height: auto;
			}

			.empty_texts {
				display: flex;
				flex-direction: column;
				color: #C0C4CC;
				line-height: 1;
				cursor: pointer;

				.empty_text {
					font-size: 15px;
					margin-bottom: 10px;
				}

				.empty_link {
					font-size: 17px;
					border-bottom: 1px solid #C0C4CC;
					padding-bottom: 2px;
				}
			}
		}

		.data_box {
			display: flex;
			flex-direction: column;
			line-height: 1;
			margin-bottom: 30px;

			.cells_box {
				display: flex;

				.cells_flex {
					display: flex;
					flex-direction: column;
					flex: 1;
				}
			}

			.cells_title {
				font-size: 15px;
				margin-top: 30px;
			}

			.chart_box {
				padding: 10px;
				box-sizing: border-box;
			}

			.cells {
				display: flex;
				margin-top: 30px;

				.cell {
					width: 200px;
					height: 100px;
					margin-right: 30px;
					border-radius: 15px;
					color: #333;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;

					&.bg1 {
						background-color: #FEF5EB;
					}

					&.bg2 {
						background-color: #E6EAFE;
					}

					&.bg3 {
						background-color: #D9EFD0;
					}

					.cell_hd {
						display: inline-flex;
						align-items: flex-end;

						.value {
							font-size: 48px;
						}

						.unit {
							font-size: 17px;
							margin-bottom: 8px;
							margin-left: 3px;
						}
					}

					.cell_ft {
						display: inline-flex;
					}
				}
			}
		}


	}
</style>